/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SettingType } from '../../../common/enums';
import { XrxControlBaseComponent } from './xrx-control-base.component';
import { OptionListOptions } from '../../services/workflow.service';

@Component({
  selector: 'xrx-multi-translation',
  templateUrl: './xrx-multi-translation.component.html',
  styleUrls: ['./xrx-multi-translation.component.less'],
  providers: [
    {
      provide: XrxControlBaseComponent,
      useExisting: XrxMultiTranslationComponent,
    },
  ],
  standalone: false,
})
export class XrxMultiTranslationComponent
  extends XrxControlBaseComponent
  implements OnInit
{
  @Input() isMfd: boolean;
  @Input() id: string;
  @Input() sort = false;
  @Input() setting: any;
  @Input() property: string;
  @Input() localize: string;
  @Input() type: string;
  @Input() error: string;
  @Input() orderby: string;
  @Input() dir = 'asc';
  @Input() required: boolean;

  @Input() list: any[];
  @Input() list2: any[];
  @Input() label: string;
  @Input() label2: string;
  @Input() inlineLabel: string;
  @Input() inlineLabel2: string;
  @Input() selectedItem: any;
  @Input() selectedItem2: any;
  @Output() change = new EventEmitter<any>();
  @Output() change2 = new EventEmitter<any>();
  @Output() validation = new EventEmitter<boolean>();
  @Output() selectedItemChange = new EventEmitter<OptionListOptions>();
  @Output() selectedItem2Change = new EventEmitter<OptionListOptions>();

  sameLanguageError: boolean;
  atLeastOneError: boolean;
  toLanguageTouched = false;

  public get SettingType(): typeof SettingType {
    return SettingType;
  }

  ngOnInit() {
    if (
      this.setting.value2 &&
      this.list2.filter((x) => x.checked === true).length == 0
    ) {
      this.loadSavedValues();
    }

    this.validateAll();
  }

  loadSavedValues() {
    const savedLanguages = JSON.parse(this.setting.value2);
    this.setting.selectedValue2 = [];

    savedLanguages.forEach((item: any) => {
      this.setting.selectedValue2.push(item);
    });
  }

  /**
   * can be called by parent component
   */
  validate() {
    this.toLanguageTouched = true;
    this.validateAll();
  }

  onFromLanguageChange(selectedItem: any) {
    this.setting.selectedValue = selectedItem;
    this.setting.value = selectedItem.value;
    const toLanguages = this.list2.filter((x) => x.checked === true);
    this.validateSameLanguage(toLanguages);
    this.validation.emit(!this.sameLanguageError);
  }

  onToLanguageChange() {
    this.toLanguageTouched = true;
    const toLanguages = this.list2.filter((x) => x.checked === true);
    const toLanValues = toLanguages.map((i) => i.value);
    this.setting.value2 = JSON.stringify(toLanValues);

    this.validateSameLanguage(toLanguages);
    this.validateNoSelection(toLanguages);
    this.validation.emit(!(this.atLeastOneError || this.sameLanguageError));
  }

  private validateSameLanguage(toLanguages: any) {
    this.sameLanguageError = false;
    const matchingLanguage = toLanguages.find(
      (x: any) =>
        x.value === this.setting.selectedValue?.value && x.checked == true,
    );
    if (matchingLanguage) {
      matchingLanguage.matchesToLanguage = true;
      this.sameLanguageError = true;
    } else {
      this.list2.forEach((item: any) => (item.matchesToLanguage = null));
    }
  }

  private validateNoSelection(toLanguages: any) {
    this.atLeastOneError = false;
    if (!toLanguages.length) {
      this.atLeastOneError = true;
    }
  }

  private validateAll() {
    const toLanguages = this.list2.filter((x) => x.checked === true);
    this.validateSameLanguage(toLanguages);
    this.validateNoSelection(toLanguages);
    this.validation.emit(
      !(
        this.atLeastOneError ||
        this.sameLanguageError ||
        !this.setting.selectedValue
      ),
    );
  }
}
